import { duration } from '../utils/duration';

// Depend on invite sub feature we may change behavior of invite feature
// For example: invite_no_energy will re place 10 gems to one energy
// Other will be used just for analytics sub feature
export type SocialSubFeature =
  | 'invite_icon'
  | 'invite_icon_energy_gift'
  | 'invite_gems_icon'
  | 'invite_launch'
  | 'invite_unlock'
  | 'invite_low_balance'
  | 'invite_instead_gems_shop'
  | 'invite_no_energy'
  | 'invite_share_gems_reward'
  | 'invite_share_gems_reward_success';

export const inviteFriendListLimit = 100;

export const inviteFriendListSelectionLimit = 10;

export const recentInviteDuration = duration({ days: 30 });

export const inviteRewardGems = 10;
export const inviteRewardEnergy = 1;

export const minigamesToUnlockInvite = 1;

export const coinsLessThanToUnlockInvite = 100;

// Reward for inviting friends to play
export const inviteShareGemsReward = 5;

// Reward for when invited friend join the game
export const inviteShareGemsRewardSuccess = 20;

// Maximum amount of gems that can be earned in a single time from inviting friends
export const inviteShareGemsRewardSuccessCap = 100;
